module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large2-8ed1df5407249e1ae7b95d9aa753d96b.jpg";